import { useState } from "react";
import Flex from "../../common/Flex";
import Slider from "../../common/Slider";
import type { FilterComponent } from "../filter.types";
import Typography from "../../common/Typography";
import config from "@/configs/config";
import useDebounceCallback from "@/shared/hooks/useDebouncCallback";
import { minutesToTime, timeToMinutes } from "@/shared/libs/actions-utils";
import { useSearchParams } from "next/navigation";

const TimeSliderFilter: FilterComponent<{
  min: string;
  max: string;
}> = ({ value, applyFilter, placeholder, filterName, currentValue }) => {
  const { min, max } = value ?? { min: "06:30", max: "00:00" };

  // Convert default times to minutes
  const defaultMinMinutes = timeToMinutes(min);
  const defaultMaxMinutes = timeToMinutes(max);
  const currentState = currentValue || useSearchParams().get("time");

  const [timeMinutes, setTimeMinutes] = useState(
    currentState
      ? currentState.split("-").map(timeToMinutes)
      : [defaultMinMinutes, defaultMaxMinutes]
  );

  const debouncedApplyFilter = useDebounceCallback((values: number[]) => {
    const timeString = values.map(minutesToTime).join("-");
    applyFilter(timeString)();
  }, 500);

  const handleTimeChange = (values: number[]) => {
    setTimeMinutes(values);
    debouncedApplyFilter(values);
  };

  return (
    <Flex direction={"col"} className="py-5" gap={"4"}>
      <Slider
        dir={config.dir}
        onValueChange={handleTimeChange}
        defaultValue={timeMinutes}
        min={defaultMinMinutes}
        max={defaultMaxMinutes}
        step={30} // 30 minute steps
        classNames={{
          range: "bg-primary",
          thumb: {
            root: "border-[3px] border-primary",
            values: "text-sm",
          },
        }}
      />
      <Flex direction={"row"} alignItems={"center"} justifyContent={"between"}>
        <Typography variant={"body3"}>
          {minutesToTime(timeMinutes[0])}
        </Typography>
        <Typography variant={"body3"}>
          {minutesToTime(timeMinutes[1])}
        </Typography>
      </Flex>
    </Flex>
  );
};

export default TimeSliderFilter;
